import Step from "./Step";

const Stepper = ({step, order}) => (
  <ul>
    <li>
      <Step n={1} title={"Zamówienie potwierdzone"} active={step>=1?true:false} content={null} />
    </li>
    <li>
      <Step n={2} title={"Przyjęto do realizacji"} active={step>=2?true:false} content={"Zamówienie trafiło do producenta"} />
    </li>
    <li>
      <Step n={3} title={"Realizacja"} active={step>=3?true:false}  content={"Komputer na tym etapie jest składany przez profesjonalnych monterów a następnie poddawany jest on rygorystycznym testom działu kontroli jakości"}/>
    </li>
    <li>
      <Step n={4} title={"Wysyłka"} active={step>=4?true:false} content={"Komputer jest już w drodze"} shipment={order.track} />
    </li>
    <li>
      <Step n={5} title={"Dostarczone"} active={step>=5?true:false}/>
    </li>
  </ul>
);

export default Stepper;
